// Lote.js – versión estilizada
import React, { useState, useMemo } from 'react';
import { Tooltip, Fade, Button, Box } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import ScheduleIcon from '@mui/icons-material/Schedule';

const Lote = ({ lote, currencySymbol, onSeleccionarLote }) => {
  const [isHovered, setIsHovered] = useState(false);

  const clickable = lote.ContratoActivo !== 1 && lote.ReservaActiva !== 1;
  const onClickHandler = clickable ? () => onSeleccionarLote(lote) : undefined;

  const priceFmt = useMemo(
    () => (n) =>
      parseFloat(n).toLocaleString('es-AR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    []
  );

  const tooltipText =
    lote.ContratoActivo === 1
      ? `${lote.Lote} · VENDIDO`
      : lote.ReservaActiva === 1
      ? `${lote.Lote} · RESERVADO hasta ${lote.FechaVencimiento} · ${currencySymbol} ${priceFmt(
          lote.Precio
        )}`
      : `${lote.Lote} · ${currencySymbol} ${priceFmt(lote.Precio)} · ${lote.Superficie} m²`;

  // Paleta por estado
  const state = lote.ContratoActivo === 1 ? 'sold' : lote.ReservaActiva === 1 ? 'hold' : 'free';

  const baseSx = {
    width: 54,
    height: 54,
    minWidth: 0,
    borderRadius: 2,
    color: '#333',
    fontWeight: 700,
    boxShadow: '0 4px 12px rgba(0,0,0,0.18)',
    transition: 'transform .15s ease, box-shadow .15s ease, filter .2s',
    '&:active': { transform: clickable ? 'scale(0.98)' : 'none' },
  };

  const stateSx =
    state === 'sold'
      ? {
          bgcolor: '#9e9e9e',
          cursor: 'not-allowed',
          filter: 'grayscale(0.2)',
        }
      : state === 'hold'
      ? {
          bgcolor: '#ff9800',
          '&:hover': { boxShadow: '0 6px 16px rgba(255,152,0,.45)' },
          position: 'relative',
          // anillo pulsante sutil
          '&::after': {
            content: '""',
            position: 'absolute',
            inset: -2,
            borderRadius: 10,
            border: '2px solid rgba(255,152,0,.45)',
            animation: 'pulse 1.6s ease-in-out infinite',
          },
        }
      : {
          bgcolor: '#2e7d32',
          '&:hover': {
            boxShadow: '0 6px 18px rgba(46,125,50,.45)',
            filter: 'drop-shadow(0 0 6px rgba(76,175,80,.45))',
          },
        };

  return (
    <>
      {/* animación pulse */}
      <style>
        {`@keyframes pulse { 0%{opacity:.5} 50%{opacity:1} 100%{opacity:.5} }`}
      </style>

      <Tooltip title={tooltipText} TransitionComponent={Fade} TransitionProps={{ timeout: 160 }} arrow>
        <Button
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={onClickHandler}
          disableRipple={!clickable}
          sx={{...baseSx,...stateSx,cursor: clickable ? 'pointer' : 'default',color: isHovered ? '#000' : '#fff',}}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              fontSize: 14,
              lineHeight: 1,
            }}
          >
            {state === 'sold' ? <LockIcon sx={{ fontSize: 16 }} /> : null}
            {state === 'hold' ? <ScheduleIcon sx={{ fontSize: 16 }} /> : null}
            {lote.Lote}
          </Box>
        </Button>
      </Tooltip>
    </>
  );
};

export default Lote;
